import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  showUpdate,
  remove,
  getList,
  copiarTrocasControladores,
  getControladorList,
  removeTrocaPlanoControlador,
  createUpdateTrocaPlanoControlador,
  updateTrocaPlanoControlador,
  updateTrocaPlanoControladorGeral,
  setPaginaAtual,
  getPlanosVinculados,
} from './trocaPlanoActions';
import SPButton from '../common/form/spButton';
import { toastr } from 'react-redux-toastr';
import { Modal } from 'react-bootstrap';
import ReactLoading from 'react-loading';
import { getConfig } from '../configuracao/configLocal';
import html2canvas from 'html2canvas';

import ReactTableGT2A from '../common/grid/gridReactTable';
import ButtonTooltip from '../common/form/buttonTooltip';
import swal from 'sweetalert2';
import If from '../common/operator/if';
import PermissaoUsuario from '../auth/permissao';

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

class TrocaPlanoList extends Component {
  constructor(props) {
    super(props);

    this.copiarDadosControladores = this.copiarDadosControladores.bind(this);
    this.lerTrocaPlanoControlador = this.lerTrocaPlanoControlador.bind(this);
    this.salvarControladorDB = this.salvarControladorDB.bind(this);
    this.lerTrocaPlanoSistema = this.lerTrocaPlanoSistema.bind(this);
    this.salvarTrocaPlanoControlador = this.salvarTrocaPlanoControlador.bind(this);

    this.componentRef = React.createRef();

    this.state = {
      salvarDB: false,
      show: false,
    };
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  // Método para capturar todas as páginas da tabela de forma invisível
  captureAllPages = async () => {
    const data = this.props.list || [];
    const pageSize = 15; // Tamanho da página definido no ReactTableGT2A
    const totalPages = Math.ceil(data.length / pageSize);
    const images = [];
    const currentPage = this.props.paginaAtual;

    try {
      // Capturar cada página silenciosamente
      for (let page = 0; page < totalPages; page++) {
        // Navegar para a página silenciosamente
        this.props.setPaginaAtual(page);

        // Aguardar a renderização (tempo reduzido)
        await sleep(400);

        // Capturar a imagem da página atual
        const canvas = await html2canvas(this.componentRef.current, {
          useCORS: true,
          scale: 0.8, // Reduzir escala para performance
          logging: false,
          allowTaint: true,
        });
        const image = canvas.toDataURL('image/png', 0.7);
        images.push(image);
      }

      // Sempre voltar para a página 1 (índice 0)
      this.props.setPaginaAtual(0);
      await sleep(200);

      return images;
    } catch (error) {
      console.error('Erro ao capturar páginas:', error);
      // Em caso de erro, captura apenas a página atual
      const canvas = await html2canvas(this.componentRef.current);
      const image = canvas.toDataURL('png');

      // Voltar para página 1
      this.props.setPaginaAtual(0);

      return [image];
    }
  };

  copiarDadosControladores() {
    swal({
      title: 'Enviar as "Tabelas de Troca" desse Controlador para os Controladores do mesmo grupo físico?',
      html: '<h5>Essa ação vai substituir as configurações existentes.</h5>',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: 'false',
    }).then(result => {
      if (result.value) {
        const data = this.props.list || [];

        this.setState({ show: true });

        this.props
          .copiarTrocasControladores()
          .then(result => {
            if (!result.error) {
              this.props
                .updateTrocaPlanoControladorGeral(data)
                .then(result2 => {
                  this.setState({ show: false });

                  if (result2.error) {
                    toastr.warning('Atenção', result2.payload.response.data || 'Falha ao atualizar controladores');
                  } else {
                    toastr.success('Sucesso', 'Operação Realizada com sucesso.');
                  }
                })
                .catch(e2 => {
                  this.setState({ show: false });
                  toastr.warning(
                    'Atenção',
                    e2.response && e2.response.data && e2.response.data.errors
                      ? e2.response.data.errors.join('<br />')
                      : 'Falha ao atualizar controladores',
                  );
                });
            } else {
              toastr.warning('Atenção', result.payload.response.data || 'Falha ao realizar a cópia dos dados');
            }
          })
          .catch(e => {
            this.setState({ show: false });
            toastr.warning(
              'Atenção',
              e.response && e.response.data && e.response.data.errors
                ? e.response.data.errors.join('<br />')
                : 'Falha ao realizar a cópia dos dados',
            );
          });
      }
    });
  }

  handleClose() {
    this.setState({ show: false });
  }

  lerTrocaPlanoControlador() {
    this.setState({ show: true });

    this.props
      .getControladorList()
      .then(result => {
        this.setState({ show: false });

        if (result.error) {
          //se retornar true no erro, chama o metodo que pega do banco
          toastr.error('Erro', result.payload.response.data.errors[0]);
          this.props.getList();
        } else {
          toastr.success('Sucesso', 'Operação Realizada com sucesso.');
          this.setState({ salvarDB: true });
        }
      })
      .catch(e => {
        this.setState({ show: false });
        toastr.error('Erro', e.response.data.errors[0]);
        this.props.getList(getConfig('cont'), this.props['data-plano']);
      });
    // }
  }

  lerTrocaPlanoSistema() {
    this.props.getList();
    this.setState({ salvarDB: false });
  }

  async salvarControladorDB() {
    let confirma = false,
      cancela = true,
      message = 'Substituir os dados atuais do sistema pelos dados do controlador?',
      tipo = 'question',
      botao = 'Sim',
      valido = true;

    const data = this.props.list || [];

    for (let index = 0; index < data.length; index++) {
      if (!data[index].valido) {
        cancela = false;
        message = 'Cadastre o plano ' + data[index].plano_id + ' em Planos do Controlador';
        tipo = 'info';
        valido = false;
        botao = 'Fechar';
        break;
      }
      delete data[index].valido;
    }

    await swal({
      title: message,
      type: tipo,
      showCancelButton: cancela,
      confirmButtonColor: 'primary',
      confirmButtonText: botao,
      cancelButtonText: 'Não',
      allowOutsideClick: 'false',
    }).then(result => {
      confirma = valido && result.value;
    });

    await sleep(1000);

    if (confirma) {
      this.setState({ show: true });
      this.setState({ salvarDB: false });

      if (data.length > 0) {
        this.props
          .removeTrocaPlanoControlador()
          .then(async result => {
            if (result.error) {
              //se retornar true no erro, chama o metodo que pega do banco
              this.setState({ show: false });
              toastr.error('Erro', result.payload.response.data.errors[0]);
            } else {
              // Coleta todas as promessas das ações de criação/atualização
              const savePromises = data.map(item => this.props.createUpdateTrocaPlanoControlador(item));

              // Espera todas as promessas terminarem
              await Promise.all(savePromises);

              // Agora que tudo foi salvo, busca a lista atualizada
              this.props.getList();
              this.setState({ show: false });
              toastr.success('Sucesso', 'Dados do controlador salvos no sistema.');
            }
          })
          .catch(e => {
            this.setState({ show: false });
            toastr.error('Erro', e);
          });
      } else {
        // se não houver dados, apenas fecha o modal
        this.setState({ show: false });
      }
    }
  }

  validaDiasTrocaPlano(data) {
    let semana = {
      dom: false,
      seg: false,
      ter: false,
      qua: false,
      qui: false,
      sex: false,
      sab: false,
    };

    let diasSemPlano = '';

    for (const key in data) {
      if (!semana.dom && parseInt(data[key].domingo) === 1) {
        semana.dom = true;
      }
      if (!semana.seg && parseInt(data[key].segunda) === 1) {
        semana.seg = true;
      }
      if (!semana.ter && parseInt(data[key].terca) === 1) {
        semana.ter = true;
      }
      if (!semana.qua && parseInt(data[key].quarta) === 1) {
        semana.qua = true;
      }
      if (!semana.qui && parseInt(data[key].quinta) === 1) {
        semana.qui = true;
      }
      if (!semana.sex && parseInt(data[key].sexta) === 1) {
        semana.sex = true;
      }
      if (!semana.sab && parseInt(data[key].sabado) === 1) {
        semana.sab = true;
      }
    }

    if (!semana.dom) {
      diasSemPlano += '"Domingo", ';
    }
    if (!semana.seg) {
      diasSemPlano += '"Segunda", ';
    }
    if (!semana.ter) {
      diasSemPlano += '"Terça", ';
    }
    if (!semana.qua) {
      diasSemPlano += '"Quarta", ';
    }
    if (!semana.qui) {
      diasSemPlano += '"Quinta", ';
    }
    if (!semana.sex) {
      diasSemPlano += '"Sexta", ';
    }
    if (!semana.sab) {
      diasSemPlano += '"Sábado", ';
    }
    return diasSemPlano;
  }

  async salvarTrocaPlanoControlador() {
    let confirma = false;
    await swal({
      title: 'Enviar as configurações de trocas de plano para o controlador?',
      html: '<h5>Essa ação vai substituir as configurações existentes no controlador.</h5>',
      type: 'question',
      showCancelButton: true,
      confirmButtonColor: 'primary',
      confirmButtonText: 'Enviar',
      cancelButtonText: 'Cancelar',
      allowOutsideClick: 'false',
    }).then(result => {
      confirma = result.value;
    });

    await sleep(1000);

    if (confirma) {
      this.setState({ show: true }); // da show no modal de aguarde
      const data = this.props.list || [];
      let diasSemPlano = this.validaDiasTrocaPlano(data);

      if (!diasSemPlano) {
        try {
          // Capturar múltiplas páginas da tabela
          const images = await this.captureAllPages();

          // Adicionar todas as imagens aos dados para visualização inteligente no log
          const pageSize = 15;
          const dataWithImage = data.map((item, index) => {
            const pageIndex = Math.floor(index / pageSize);

            // Criar objeto com todas as imagens para o log
            const imageLogData = {
              currentPageImage: images[pageIndex] || images[0], // Imagem da página onde o item aparece
              allImages: images, // Todas as imagens para visualização no log
              pageNumber: pageIndex + 1,
              totalPages: images.length,
              itemIndex: index,
            };

            return {
              ...item,
              imageLog: JSON.stringify(imageLogData), // Serializar para envio ao backend
            };
          });

          this.props
            .updateTrocaPlanoControlador(dataWithImage)
            .then(result => {
              this.setState({ show: false });

              if (result.error) {
                //se retornar true no erro, chama o metodo que pega do banco
                toastr.error('Erro', result.payload.response.data.errors[0]);
              } else {
                toastr.success('Sucesso', 'Trocas de Plano enviadas com sucesso.');
              }
            })
            .catch(e => {
              this.setState({ show: false });
              toastr.error('Erro', e.response.data.errors[0]);
            });
        } catch (error) {
          console.error('Erro ao capturar imagem:', error);
          // Se falhar na captura da imagem, envia sem imagem
          this.props
            .updateTrocaPlanoControlador(data)
            .then(result => {
              this.setState({ show: false });

              if (result.error) {
                toastr.error('Erro', result.payload.response.data.errors[0]);
              } else {
                toastr.success('Sucesso', 'Trocas de Plano enviadas com sucesso.');
              }
            })
            .catch(e => {
              this.setState({ show: false });
              toastr.error('Erro', e.response.data.errors[0]);
            });
        }
      } else {
        toastr.warning('Alerta', `O(s) dia(s) da semana: ${diasSemPlano} não tem plano cadastrado.`);
        this.setState({ show: false });
      }
    }
  }

  async removerTrocaPlano(data) {
    if (data.id > 0) {
      try {
        // Verificar se a tabela de troca está vinculada a algum plano
        const controladorId = getConfig('cont');
        console.log('Debug - Troca ID:', data.id, 'Controlador ID:', controladorId);
        const resultPlanosVinculados = await this.props.getPlanosVinculados(data.id, controladorId);
        console.log('Debug - Resultado API:', resultPlanosVinculados);
        const planosVinculados = resultPlanosVinculados.payload.data || [];
        console.log('Debug - Planos vinculados:', planosVinculados);

        let title = 'Deseja realmente excluir?';
        let html = '';
        let type = 'question';

        if (planosVinculados.length > 0) {
          // Existe plano vinculado - mostrar aviso informativo
          const planosInfo = planosVinculados.map(p => `${p.plano_id} (${p.plano_descricao})`).join(', ');

          title = 'Tabela de Troca vinculada a Plano';
          html = `<p><strong>Essa tabela de troca está vinculada ao(s) plano(s) ${planosInfo}.</strong></p>
                  <p><strong>Deseja continuar com a exclusão?</strong></p>`;
          type = 'warning';
        }

        swal({
          title: title,
          html: html || undefined,
          type: type,
          showCancelButton: true,
          confirmButtonColor: planosVinculados.length > 0 ? '#d33' : 'primary',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          allowOutsideClick: false,
          width: planosVinculados.length > 0 ? '600px' : undefined,
        }).then(result => {
          if (result.value) {
            this.props.remove(data);
          }
        });
      } catch (error) {
        console.error('Erro ao verificar planos vinculados:', error);
        console.error('Detalhes do erro:', error.response && error.response.data);
        // Em caso de erro, mostrar modal normal
        swal({
          title: 'Deseja realmente excluir?',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: 'primary',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          allowOutsideClick: false,
        }).then(result => {
          if (result.value) {
            this.props.remove(data);
          }
        });
      }
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido exclusão ou alteração sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  alterarTrocaPlano(data) {
    if (data.id > 0) {
      this.props.showUpdate(data);
    } else {
      toastr.warning(
        'Alerta',
        `Não é permitido exclusão ou alteração sem antes salvar no sistema. Clique no botão "Salvar no sistema" primeiro`,
      );
    }
  }

  render() {
    const trocaPlano = this.props.list || [];
    const paginaAtual = this.props.paginaAtual;

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <SPButton
                type="button"
                className="warning btn-sm"
                icon="pencil-alt"
                data-title="Alterar"
                onClick={() => this.alterarTrocaPlano(row.original)}
              />
              <SPButton
                type="button"
                className="danger btn-sm"
                icon="trash-alt"
                data-title="Excluir"
                onClick={() => this.removerTrocaPlano(row.original)}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <SPButton type="button" className="warning btn-sm" icon="pencil-alt" disabled="disabled" />
              <SPButton type="button" className="danger btn-sm" icon="trash-alt" disabled="disabled" />
            </PermissaoUsuario>
          </div>
        ),
        width: 90,
        filterable: true,
        className: 'column_icon',
        Filter: () => (
          <div className="rt-th">
            <span>Filtrar</span>
          </div>
        ),
      },
      {
        Header: 'Plano',
        accessor: 'plano_tratado',
        width: 50,
        className: 'column_grid column_center',
        filterable: true,
      },
      {
        Header: 'Tabela',
        accessor: 'id',
        width: 50,
        className: 'column_grid column_center',
        filterable: true,
      },
      {
        Header: 'Dom',
        accessor: 'domingo',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Seg',
        accessor: 'segunda',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Ter',
        accessor: 'terca',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Qua',
        accessor: 'quarta',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Qui',
        accessor: 'quinta',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Sex',
        accessor: 'sexta',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Sab',
        accessor: 'sabado',
        width: 40,
        className: 'column_grid column_center',
        Cell: ({ value }) => (value == 1 ? 'Sim' : 'Não'),
      },
      {
        Header: 'Horário',
        accessor: 'horario_inicial',
        className: 'column_grid column_center',
        width: 100,
      },
    ];

    return (
      <div ref={this.componentRef}>
        <Modal show={this.state.show} onHide={this.handleClose} dialogClassName="modal-load" backdrop={false}>
          <Modal.Body className="modal-body modal-load-body">
            <div>
              <div>
                <ReactLoading className="react-loading" type="spokes" color="#367fa9" height={50} width={50} />
              </div>
              <div>
                <h4>
                  <b>Aguarde, processando...</b>
                </h4>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <ReactTableGT2A
          data={trocaPlano}
          columns={columns}
          className="-striped -highlight"
          defaultPageSize={15}
          onPageChange={this.handlePageChange}
          page={paginaAtual}
        />
        <div className="box-footer troca-plano-footer" style={{ display: 'flex', alignItems: 'flex-start' }}>
          <div className="troca-plano-footer-left" style={{ display: 'flex', gap: '8px' }}>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataLerControlador"
                className="success"
                icon="download"
                label="Ler do Controlador"
                data-title="Busca os dados do controlador"
                onClick={this.lerTrocaPlanoControlador}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <ButtonTooltip type="button" className="success" icon="download" label="Ler do Controlador" disabled />
            </PermissaoUsuario>

            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataEnviarControlador"
                className="primary"
                icon="upload"
                label="Enviar para esse Controlador"
                data-title="Envia os dados para o controlador"
                onClick={this.salvarTrocaPlanoControlador}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                className="primary"
                icon="upload"
                label="Enviar para esse Controlador"
                disabled
              />
            </PermissaoUsuario>

            <If condicao={this.state.salvarDB}>
              <>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    id="btnDataTrocaPlanoSalvarDB"
                    className="primary"
                    icon="check"
                    label="Salvar no sistema"
                    data-title="Salva no sistema os dados que vieram do controlado"
                    onClick={this.salvarControladorDB}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
                  <ButtonTooltip type="button" className="primary" icon="check" label="Salvar no sistema" disabled />
                </PermissaoUsuario>
              </>
            </If>

            <If condicao={this.state.salvarDB}>
              <>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
                  <ButtonTooltip
                    type="button"
                    id="btnTrocaPlanoLerSistema"
                    className="primary"
                    icon="file-download"
                    label="Ler do sistema"
                    data-title="Busca os dados do banco de dados do sistema"
                    onClick={this.lerTrocaPlanoSistema}
                  />
                </PermissaoUsuario>
                <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
                  <ButtonTooltip
                    type="button"
                    className="primary"
                    icon="file-download"
                    label="Ler do sistema"
                    disabled
                  />
                </PermissaoUsuario>
              </>
            </If>
          </div>

          <div className="troca-plano-footer-right" style={{ marginLeft: 'auto' }}>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={true}>
              <ButtonTooltip
                type="button"
                id="btnDataReplicarTrocaPlano"
                className="warning"
                icon="copy"
                label="Enviar para Todos os Controladores"
                data-title="Replica a troca de plano para os controladores do grupo físico"
                onClick={this.copiarDadosControladores}
              />
            </PermissaoUsuario>
            <PermissaoUsuario tela="CadTrocaPlano" condicao={false}>
              <ButtonTooltip
                type="button"
                className="warning"
                icon="copy"
                label="Enviar para Todos os Controladores"
                disabled
              />
            </PermissaoUsuario>
          </div>
        </div>
      </div>
    );
  }
}
// busca o planoCad la do reducers.js
const mapStateToProps = state => ({
  list: state.trocaPlanoCad.list,
  paginaAtual: state.trocaPlanoCad.paginaAtual,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      showUpdate,
      remove,
      getList,
      copiarTrocasControladores,
      getControladorList,
      removeTrocaPlanoControlador,
      createUpdateTrocaPlanoControlador,
      updateTrocaPlanoControlador,
      updateTrocaPlanoControladorGeral,
      setPaginaAtual,
      getPlanosVinculados,
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TrocaPlanoList);
